import src from "IMAGE";
export default { src, width: 1336, height: 246, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
